import React, { Component } from 'react'
import ChartistGraph from 'react-chartist'
import Legend from "chartist-plugin-legend";
import PointLabels from 'chartist-plugin-pointlabels'
import GraphCard from 'components/GraphCard/GraphCard'
import { Grid, Row, Col } from 'react-bootstrap'
import { FamilyCard } from 'components/FamilyCard'
import {Card} from 'components/Card/Card'
import {StatsCard} from 'components/StatsCard/StatsCard'
import {StartEndGraph} from 'components/StartEndGraph/StartEndGraph'
import {StatsNowEPmbo, StatsEPmbo, DevBuild, DemoBuild /*, instance */ } from 'variables/Config'
import { dataSales, optionsSales, responsiveSales, legendSales } from 'variables/Variables'
import YSpinner from '../../elements/Spinner/Spinner'
//import {DigmaTasks} from 'components/Tasks/DigmaTasks.jsx';
import { responsiveBar } from 'variables/Variables.jsx'

const legendPie = (list) => {
    if (list === undefined || list === false)
        return ({ names: 'untitled' })

    let l = list.map(item => item['title'])
    return ({ names: l })
}
const rdata = (list) => {
    if (list === undefined || list === false)
        return ({value: 0, className: 'legendNo-0'}) 

    let l = list.map(item => item['total'])
    let s = list.map((item, index) => {
        return ({value: item['total'], className: 'legendNo-'+ index}) 
    })
    /*let o = {
        seriesBarDistance: 10,
        reverseData: true,
        horizontalBars: true,
        axisY: {
          offset: 70
        }
      }*/
    return ({ labels: l, series: s })
}
const YahavDBStatsContext = React.createContext()

class YahavDBStatsProvider extends Component {
    state = { cpt: ''}
    
    render() {
      return (
        <YahavDBStatsContext.Provider value={{ state: this.state }}>
          {this.props.children}
        </YahavDBStatsContext.Provider>
      )
    }
}
// extract values from stat atructure 
// full may refere to phase 2
export const cptFind = ( table, value, full) => {
    if (table === undefined) return 0
    let i = 0
    for (i = 0; i < table.length; i++){
        if (table[i]['title'] === value){
            if (full !== undefined)
                return parseInt(table[i]['total_full'])
            return parseInt(table[i]['total'])
        }
    }
    return 0
}
class Dashboard extends Component {
    constructor(props){
        super(props)
        this._isMounted = false
        this.state = {
            cpt: "",
            isLoading: true,
            restError: ""
        }
    }
    requestStatNow = (evt) => {
        evt.preventDefault()
        //console.log("this.requestStatNow")
        this.setState({isLoading: true})

        //this.fetchStat(this.props.hosturl ? this.props.hosturl : StatsNowEPmbo) //     instance.get_endPoint(StatsNowEPmboNew)
        //this.fetchStat(instance.get_endPoint(StatsNowEPmboNew)) //     
        this.fetchStat(StatsNowEPmbo()) //     


        //this.fetchStat(StatsEPmbo, "statnow");
    }

    fetchStat = (url) => {
        //let body = { request: 'now'}
        
        fetch(url)
        .then(response => {
            if (!this._isMounted) return null
            if (response.ok)
                return response
            // return response.json()
            throw new Error('fetchStat: response not OK, Something went wrong ...')
        })
        .then(response => {                       
            if (!this._isMounted) 
                return null
            // this.setState({cpt: response.json(), isLoading: false})
            return (response.json()) // void - no one is looking...
        }).then( (cpt) => { /*FOR DEBUG PURPOSES console.log("title",this.state.cpt['title'])*/
                this.setState({cpt, isLoading: false})  })
        .catch(restError => {
            if (restError.name === 'AbortError') return; 
            if (!this._isMounted) return null
            this.setState({ restError: restError, isLoading: false })
        })
        return null
    }

    componentDidMount(){
        // get statistics from server
        // make sure you get ask for instant calculation
        this._isMounted = true
        //this.fetchStat(this.props.hosturl? this.props.hosturl: StatsEPmbo)
        //this.fetchStat(instance.get_endPoint(StatsEPmboNew)) //     
        this.fetchStat(StatsEPmbo())    
    }
    componentWillUnmount(){
        this._isMounted = false
        // console.log("Dashboard unmounted", this.state.isLoading)
    }
    /*
    shouldComponentUpdate(){
        console.log("Dashboard shouldComponentUpdate")
        return true    }*/
    createLegend(json){
        //console.log("lengen input:", json)

        var legend = [];
        for(var i = 0; i < json["names"].length; i++){
            //var type = "fa fa-circle text-" + json["types"][i] legendNo-
            var type = "fa fa-circle legendNo-" + i 
            legend.push(
                <i className={type} key={i}></i>
            )
            legend.push(" ")
            legend.push(
                json["names"][i]
            )
        }
        //console.log("lengend result:", legend)
        return legend;
    }
    
    teamTasks(cpt) {
        const undefReferrals = parseInt(cptFind(cpt['referrals'],'נא לבחור'))
        const undefIntakes = parseInt(cptFind(cpt['intakes'],'נא לבחור')) + parseInt(cptFind(cpt['intakes'],'אחר'))
        const delayIntakes = parseInt(cptFind(cpt['intakes'],'מתעכב'))
        const undefFamilies = parseInt(cptFind(cpt['families'],'אחר'))
        return(
            <table className="table">
                <tbody>
                {undefReferrals+undefIntakes+delayIntakes+undefFamilies !== 0 ? null :
                    <tr><td>מעולה! כל ההפניות, אינטייק ומשפחות פעילות מוגדרות היטב</td></tr>}
                {undefReferrals ? <tr><td>{undefReferrals}</td><td> הפניות בסטטוס לא מוגדר ("נא לבחור")</td></tr> : null}
                {undefIntakes ? <tr><td>{undefIntakes}</td><td> אינטייק בסטטוס לא מוגדר ("אחר" או "נא לבחור")</td></tr> : null}
                {undefFamilies ? <tr><td>{undefFamilies}</td><td> משפחות בתכנית בסטטוס לא מוגדר ("אחר")</td></tr> : null}
                {delayIntakes ? <tr><td>{delayIntakes}</td><td> אינטייק בסטטוס מתעכב</td></tr> : null}
                </tbody>
            </table>
        )
    }
    update_time(time){
        return <span className="update-time">{time}</span> 
    }
    update_now_button = () => 
       <button style={{padding:'0'}} onClick={this.requestStatNow} ><i className="fa fa-refresh"></i></button>
    
    yesterday () {
                //let yesterday = ( d => new Date(d.setDate(d.getDate()-1)) )(new Date)

        let d= new Date()
        d.setDate(d.getDate() - 1)
        return "מעודכן לתאריך: " + d.getDate() + "/" + (d.getMonth()+1) + "/" + d.getFullYear()
    } 
    //         housing_legal(test1bar)
    housing_legal = (data) => {
        /*test1bar = {
            labels: ['משפטי התחלה','משפטי סיום', 'מגורים התחלה', 'מגורים סיום'],
            series: [
              [21, 31, 17, 29],
              [15, 5, 19, 7],
            ]
          };*/
        let total_legal = data.series[0][0]+data.series[1][0] 
        let legal_before = Math.round(data.series[1][0] / total_legal *100)
        let legal_after = Math.round(data.series[1][1] / total_legal *100)
        let legal_improve =  legal_before > 0 ? 100 - Math.round(legal_after / legal_before * 100) : 100;
        let housing_before = Math.round(data.series[1][2] / total_legal * 100)
        let housing_after = Math.round(data.series[1][3] / total_legal * 100)
        let housing_improve =  housing_before > 0 ? 100 - Math.round(housing_after / housing_before *100) : 100

        return "משפטי התחלה: " + legal_before + "% סיום: " + legal_after + "% שיפור: " + legal_improve +"% "
                + "מגורים התחלה: " + housing_before + "% סיום: " + housing_after + "% שיפור: " + housing_improve +"%"
    }
    // handle first & second series of before & after
    poverty_above_below = (data) => {
        let d = data.series
        console.log('d[0] ', d[0])
        console.log('d[1] ', d[1])
        let total_first = d[0].data[0]+d[1].data[0] 
        let first_before = Math.round(d[0].data[0] / total_first *100)
        let first_after = Math.round(d[0].data[1] / total_first *100)
        let first_improve =  first_before > 0 ? 100 - Math.round(first_after / first_before * 100) : 100;

        let total_second = d[0].data[2]+d[1].data[2]
        let second_before = Math.round(d[0].data[2] / total_second * 100)
        let second_after = Math.round(d[0].data[3] / total_second * 100)
        let second_improve =  second_before > 0 ? 100 - Math.round(second_after / second_before *100) : 100

        return "חד התחלה: " + first_before + "% סיום: " + first_after + "% שיפור: " + first_improve +"% "
                + "זוג התחלה: " + second_before + "% סיום: " + second_after + "% שיפור: " + second_improve +"%"
    }
    render() {
        const { cpt, isLoading } = this.state
        if (isLoading)
            return <YSpinner />
        //if (cpt['stats_daily'] === ""){
        if (!cpt || cpt === ""){
            console.log('dashboard cpt undefined')
            //this.setState({isLoading:true})
            // this.fetchStat(StatsEPmbo)
            return ( <div>
                        <h1>נא לרענן את המסך</h1>
                        <h4>בקשת עדכון אחרונה לא הושלמה כיאות<br />
                        יש להמתין לסיום והצגת העדכון<br />
                        לאחר מכן ניתן לעבור לעמוד אחר</h4>
                    </div>)
        }

        const stats_daily = cpt['stats_daily']
        const stats_referrals = cpt['referrals']
        const stats_intakes = cpt['intakes']
        const stats_families = cpt['families']
        const stats_time = cpt['timestamp']
        //const stats_sroi = cpt['sroi']
        //const stopped = parseInt(stats_families[2]['total'])+parseInt(stats_families[3]['total'])+parseInt(stats_families[4]['total'])
        const stopped = cptFind(cpt['families'], "פורשת")
                        + cptFind(cpt['families'], "מסיימת לפני הזמן בהסכמה")
                        + cptFind(cpt['families'], "מסיימת בהחלטת התכנית")

        const graduated = cptFind(cpt['families'], "בוגרת")   //parseInt(stats_families[1]['total'])
        const inprogram = cptFind(cpt['families'], "בתכנית")   // parseInt(stats_families[0]['total'])
        // const inIntake = parseInt(stats_intakes[2]['total'])+parseInt(stats_intakes[3]['total'])
        const inIntake = cptFind(cpt['intakes'], "באינטייק")+cptFind(cpt['intakes'], "נא לבחור")

        // const inReferral = parseInt(stats_referrals[5]['total'])+parseInt(stats_referrals[6]['total'])+parseInt(stats_referrals[7]['total'])
        const inReferral = cptFind(cpt['referrals'], "ברור עם המשפחה")
                            +cptFind(cpt['referrals'], "ברור עם גורם מפנה")
                            +cptFind(cpt['referrals'], "התקבלה פניה. טרם התבצע בירור")

        //const endReferral = parseInt(stats_referrals[1]['total'])+parseInt(stats_referrals[2]['total'])+parseInt(stats_referrals[3]['total'])
        const endReferral = cptFind(cpt['referrals'], "סיום. אין התאמה")
                            +cptFind(cpt['referrals'], "סיום. המשפחה ויתרה")
                            +cptFind(cpt['referrals'], "סיום. יש פוטנציאל")
        var test1bar = {
                                labels: ['משפטי התחלה','משפטי סיום', 'מגורים התחלה', 'מגורים סיום'],
                                series: [
                                  [21, 31, 17, 29],
                                  [15, 5, 19, 7],
                                ]
                              };
        var test1legendBar = {
                                names: ["לא זקוקות לסיוע","זקוקות לסיוע"]//,types: ["info", "danger","warning"]
                            }
        var test1optionsBar = {
                                stackBars: true,
                                seriesBarDistance: 10,
                                axisX: {
                                    showGrid: false
                                },
                                height: "150px"
                            }
        
        /* var options_poverty = {
                                stackBars: true,
                                seriesBarDistance: 10,
                                axisX: {
                                    showGrid: false,
                                   // labelInterpolationFnc: function(value, index) {
                                   //     return yLabels[index];
                                   // },
                                    strech: true
                                },
                                height: "150px",
                             //   plugins: [ctBarLabels()] // Chartist.plugins.
                            }
                            
        var data_poverty = {
                                labels: ['חד-הורי התחלה','חד-הורי סיום', 'זוג התחלה','זוג סיום'],
                                // series: [ [21, 31], [15, 5]  ]
                                series: [{
                                            name: 'series-start',
                                            className: 'series-start',
                                            data: [8, 6, 10, 8]
                                        },
                                        {
                                            name: 'series-end',
                                            className: 'series-end',
                                            data: [0, 2, 18, 20]
                                        },
                                ]
                              }
        var legend_poverty = {  //className: 'new-class-name',
                                names: ["מעל קו העוני", "מתחת לקו העוני"]//,types: ["info", "danger","warning"]
                            }
*/
        var parentOptionsBar = {
                                seriesBarDistance: 10,
                                gridOffset: 50,
                                reverseData: true,
                                horizontalBars: true,
                                low:0,
                                high: 60,
                                axisY: {
                                    offset: 90,
                                },
                                axisX: {
                                    offset: 50,
                                    // ticks: [0,10,20,30,40,50,60,70,80,90,100],
                                    labelInterpolationFnc: function (value) {
                                        if (Number.isInteger(value))
                                            return value
                                        return ""
                                    }
                                },
                                height: '400px',
                                plugins: [
                                    Legend({position: 'top'}), 
                                    PointLabels({textAnchor: 'left', fontSize: '12px'})
                                ]
                                }
                        
       
                    /*
                    labelInterpolationFnc: function skipLabels(value, index, data) {
                                                            //if(data.series.length > 60)
                                                            //    return index % 1.5  === 0 ? value : null;
                                                            //else
                                                            console.log('value index data', value, index, data)
                                                                return value;
                                                    },
                   
        
        var parentLegendBar = {
                        names: ["בסיום התכנית","בהתחלת התכנית"]// ,    types: ["info","warning"]
                    } */
        var parentDataBar = {
                        labels: ['מאבטלה לעבודה', 'שיפור תעסוקתי', 'רשת תמיכה', 'מימוש עצמי', 'מסוגלות', 'תעסוקה', 'משפחה', 'מוטיבציה'],
                        series: [{
                            name: 'התחלת התוכנית',
                            data: [0, 0, 14, 17, 19, 22, 10, 26]},
                            {
                                name: 'סיום התוכנית',
                                data: [12, 22, 23,  35,  37, 42, 30, 44]}
                        ]
                      };
        // console.log("dashboard cpt", cpt)
        /*const graphbyhand = () => {
            const ul_style = {lineStyle:'none', direction:'ltr', textAlign: 'left'}
            const li_style = {display: 'block'}
            const span_title_style = {display: 'inline-block', width: '120px', marginRight:'20px'}
            const span_bar_style = {display: 'inline-block', padding: '2px 0 2px 0', border: '2px solid white', background: 'blue'}
            return (<ul style={ul_style}>
                        <li style={li_style}><span style={span_title_style}>כותרת</span><span style={span_bar_style}>עמודה</span></li>
                    </ul>)
        }
        var options = parentOptionsBar
        var positionX = /*options.position.x ||* / (data, offset) => {
            console.log('positionX data=', data)
            return ((data.x1 + data.x2) / 2) + offset.x //  options.labelOffset.x;
        }
    
        var positionY = /*options.position.y ||* / (data, offset) => {
            console.log('positionY data=', data)
            return ((data.y1 + data.y2) / 2) + offset.y // options.labelOffset.y;
        }
        const onDrawHandler = (e, data) => {
            if (e.type=== 'label')
                if(e.axis.options.position !== undefined && e.axis.options.position === 'end'){ //units.pos === 'x'){
                    console.log('onDrawHandler event', e)
                    //e.group.x = e.group.x - 50
                    e.x = e.x - 50
                    console.log('onDrawHandler After change ', e)

                /* e.group.elem('text', {
                    // This gets the middle point of the bars and then adds the
                    // optional offset to them
                    x: positionX(e.axis.chartRect, e.axis.options.labelOffset),
                    y: positionY(e.axis.chartRect, e.axis.options.labelOffset),
                    style: 'text-anchor: right'
                    }, options.labelClass)
                    .text(
                    options.axisX.labelInterpolationFnc(
                        (e.x || e.y) + " D"

                        // If there's not x (horizontal bars) there must be a y
                        //e.value.x || e.value.y
                    )
                    );* /
                }
            return null
        }
        */
      return (
        <YahavDBStatsProvider>
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col lg={2} sm={6}>
                            <StatsCard
                                bigIcon={<i className="pe-7s-look text-dark"></i>}
                                statsText="משפחות מסיימות"
                                statsValue={stopped}
                                statsIcon={this.update_now_button()}
                                statsIconText= {this.update_time(stats_time)}
                            />
                        </Col>
                        <Col lg={2} sm={6}>
                            <StatsCard
                                bigIcon={<i className="pe-7s-graph1 text-success"></i>}
                                statsText="משפחות בוגרות"
                                statsValue={graduated}
                                statsIcon={this.update_now_button()}
                                statsIconText= {this.update_time(stats_time)}
                            />
                        </Col>
                        <Col lg={2} sm={6}>
                            <StatsCard
                                bigIcon={<i className="pe-7s-flag text-primary"></i>}
                                statsText="משפחות פעילות"
                                statsValue={inprogram}
                                statsIcon={this.update_now_button()}
                                statsIconText= {this.update_time(stats_time)}
                            />
                        </Col>
                        <Col lg={2} sm={6}>
                            <StatsCard
                                bigIcon={<i className="pe-7s-smile text-warning"></i>}
                                statsText="משפחות באינטייק"
                                statsValue={inIntake}
                                statsIcon={this.update_now_button()}
                                statsIconText= {this.update_time(stats_time)}
                            />
                        </Col>
                        <Col lg={2} sm={6}>
                            <StatsCard
                                bigIcon={<i className="pe-7s-id text-info"></i>}
                                statsText= "הפניות שנסגרו"
                                statsValue={endReferral /*stats_daily['intakes_total']*/}
                                statsIcon={this.update_now_button()}
                                statsIconText= {this.update_time(stats_time)}
                            />
                        </Col>
                        <Col lg={2} sm={6}>
                            <StatsCard
                                bigIcon={<i className="pe-7s-users text-info"></i>}
                                statsText="הפניות בטיפול"
                                statsValue={inReferral /*stats_daily['referrals_total']*/}
                                statsIcon={this.update_now_button()}
                                statsIconText= {this.update_time(stats_time)}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>
                            <Card
                                statsIcon="fa fa-clock-o"
                                title={"משפחות בתוכנית ומסיימות (" + stats_daily['families_total'] + ")"}
                                //category="בתכנית // מסיימות"
                                stats={this.update_time(stats_time) /*this.yesterday()*/}
                                content={
                                    <div id="chartPreferences" className="ct-chart ct-perfect-fourth">
                                        <ChartistGraph data={rdata(stats_families)} type="Pie"/>
                                    </div>
                                }
                                legend={
                                    <div className="legend">
                                        {this.createLegend(legendPie(stats_families))}
                                    </div>
                                }
                            />
                        </Col>
                        <Col md={4}>
                            <Card
                                statsIcon="fa fa-clock-o"
                                title={"התפלגות כל האינטייק (" + stats_daily['intakes_total'] + ")"}
                                //category="הפניות // אינטייק // בתכנית // מסיימות"
                                stats={this.update_time(stats_time) /*this.yesterday()*/}
                                content={
                                    <div id="chartPreferences" className="ct-chart ct-perfect-fourth">
                                        <ChartistGraph data={rdata(stats_intakes)}  type="Pie"/>
                                    </div>
                                }
                                legend={
                                    <div className="legend">
                                        {this.createLegend(legendPie(stats_intakes))}
                                    </div>
                                }
                            />
                        </Col>
                        <Col md={4}>
                        <Card
                            statsIcon="fa fa-clock-o"
                            title={"התפלגות כל ההפניות (" + stats_daily['referrals_total'] + ")"}
                            //category="הפניות // אינטייק // בתכנית // מסיימות"
                            stats={this.update_time(stats_time) /*this.yesterday()*/}
                            content={
                                <div id="chartPreferences" className="ct-chart ct-perfect-fourth">
                                    <ChartistGraph data={rdata(stats_referrals)} 
                                           type="Pie"/>
                                           {/* TBC type="Bar" options={{horizontalBars: true, reverseData: true}} */}
                                </div>
                            }
                            legend={
                                <div className="legend">
                                    {/*this.createLegend(legendPie(stats_referrals))*/}
                                    {this.createLegend(legendPie(stats_referrals))}
                                </div>
                            }
                        />
                    </Col>
                    </Row>
                    { !DevBuild && !DemoBuild &&
                        <Row>
                        <Col md={8}>
                            <GraphCard
                                statsIcon="fa fa-history"
                                id="chartHours"
                                title="התנהגות משתמשים"
                                category="24 Hours performance"
                                stats="עודכן לפני 3 דקות"
                                content={
                                    <div className="ct-chart graph-card">
                                        <ChartistGraph
                                            data={dataSales}
                                            type="Line"
                                            //class="graph-card"
                                            options={optionsSales}
                                            responsiveOptions={responsiveSales}
                                        />
                                    </div>
                                    }
                                legend={
                                    <div className="legend">
                                        {this.createLegend(legendSales)}
                                    </div>
                                }
                            />
                        </Col>
                        <Col md={4}>
                            <GraphCard
                                id="chart-housing-legal"
                                title="סיוע מגורים, משפטי"
                                category= {this.housing_legal(test1bar)} // {" השוואה התחלה מול סיום" + " (36 משפחות) "}
                                className='graph-card-hist'
                                stats="עדכון מתוך תמונות מצב"
                                statsIcon="fa fa-check"
                                content={
                                    <div className="ct-chart graph-card">
                                        <ChartistGraph
                                            data={test1bar}
                                            type="Bar"
                                            options={test1optionsBar}
                                            responsiveOptions={responsiveBar}
                                        />
                                    </div>
                                }
                                legend={
                                    <div className="legend">
                                        {this.createLegend(test1legendBar)}
                                    </div>
                                }
                            />
                        </Col>
                            </Row>
                    }
                    { (DevBuild || DemoBuild) &&  
                    <Row>
                        <Col lg={3} sm={6}>
                            <StatsCard
                                bigIcon={<i className="pe-7s-graph1 text-success"></i>}
                                statsText='עלות הצלחה'
                                statsValue='6648 ש"ח' // 425478 / 37 משפחות
                                statsIcon={this.update_now_button()}
                                statsIconText= {this.update_time(stats_time)}
                            />
                        </Col>
                        <Col lg={3} sm={6}>
                            <StatsCard
                                bigIcon={<i className="pe-7s-graph1 text-success"></i>}
                                statsText='עלות מענים'
                                statsValue='5188 ש"ח' // 425478 / 67 משפחות
                                statsIcon={this.update_now_button()}
                                statsIconText= {this.update_time(stats_time)}
                            />
                        </Col>
                        <Col lg={2} sm={6}>
                                <StatsCard
                                    bigIcon={<i className="pe-7s-graph1 text-success"></i>}
                                    statsText="SROI"
                                    statsValue={cptFind(cpt['sroi'], 'roi')+'%'}
                                    statsIcon={this.update_now_button()}
                                    statsIconText= {this.update_time(stats_time)}
                                />
                        </Col>
                        <Col md={4}>
                            <Card
                                title="משימות"
                                category="שיפור הטיפול במשפחות ואיכות הנתונים במערכת"
                                // stats="מתעדכן תדיר לפי התקדמות"
                                //statsIcon="fa fa-history"
                                content={ this.teamTasks(cpt) }
                            />
                        </Col>
                   </Row>
                    }
                    { (DevBuild || DemoBuild) &&
                    <Row>
                        <Col md={6}>
                            <FamilyCard cpt={cpt}/>
                        </Col>
                        <Col md={6}>
                            <StartEndGraph 
                                    id="family-se-graph"
                                    title="שיפור מדדי תוצאה בסיום - הורים (55)"
                                    //category="השוואת מצב בין כניסה לסיום"
                                    stats="עדכון יומי"
                                    statsIcon="fa fa-check"
                                    className ="family-graph-card"
                                    data={parentDataBar}
                                    type="Bar"
                                    options={parentOptionsBar}
                                    responsiveOptions={responsiveBar}
                                />
                       
                        </Col>
                    </Row>
                   
                   }  
                    
                    {/*
                    <Row>
                    <Col md={3}>
                        <Card
                                id="chart-additional"
                                title="קו העוני"
                                category={this.poverty_above_below(data_poverty)}
                                className='graph-card-hist'
                                stats="עדכון יומי מתוך תמונות מצב"
                                statsIcon="fa fa-check"
                                content={
                                    <div className="ct-chart graph-card">
                                        <ChartistGraph
                                            data={data_poverty}
                                            type="Bar"
                                            //className="graph-card-new"
                                            options={options_poverty}
                                            responsiveOptions={responsiveBar}
                                        />
                                    </div>
                                }
                                legend={
                                    <div className="legend">
                                        {this.createLegend(legend_poverty)}
                                    </div>
                                }
                            />
                        </Col>
                        
                        <Col md={3}>
                            <Card
                                id="chart-expenses"
                                title="גרף הוצאות"
                                category={" השוואה התחלה מול סיום" + " (36 משפחות) "}
                                className='graph-card-hist'
                                stats="עדכון יומי"
                                statsIcon="fa fa-check"
                                content={
                                    <div className="ct-chart graph-card">
                                        <ChartistGraph
                                            data={test1bar}
                                            type="Bar"
                                            options={test1optionsBar}
                                            responsiveOptions={responsiveBar}
                                        />
                                    </div>
                                }
                                legend={
                                    <div className="legend">
                                        {this.createLegend(test1legendBar)}
                                    </div>
                                }
                            />
                        </Col>
                        <Col md={3}>
                            <Card
                                id="chart-income"
                                title="גרף הכנסות"
                                className='graph-card-hist'
                                category={" השוואה התחלה מול סיום" + " (36 משפחות) "}
                                stats="עדכון יומי"
                                statsIcon="fa fa-check"
                                content={
                                    <div className="ct-chart graph-card">
                                        <ChartistGraph
                                            data={{
                                                labels: ['עבודה', 'הון', 'קצבאות'],
                                                series: [
                                                  [8432, 0, 1714],
                                                  [11804, 0, 2276],
                                                ]
                                              }}
                                            type="Bar"
                                            options={{
                                                seriesBarDistance: 7,
                                                axisX: {
                                                    showGrid: false
                                                },
                                                height: "150px"
                                            }}
                                            responsiveOptions={responsiveBar}
                                        />
                                    </div>
                                }
                                legend={
                                    <div className="legend">
                                        {this.createLegend({
                                            names: ["התחלה", "אמצע", "סיום"]//,types: ["info", "danger","warning"]
                                        })}
                                    </div>
                                }
                            />
                        </Col>
                        <Col md={3}>
                            <GraphCard
                                id="chart-housing-legal"
                                title="סיוע מגורים, משפטי"
                                category= {this.housing_legal(test1bar)} // {" השוואה התחלה מול סיום" + " (36 משפחות) "}
                                className='graph-card-hist'
                                stats="עדכון יומי מתוך תמונות מצב"
                                statsIcon="fa fa-check"
                                content={
                                    <div className="ct-chart graph-card">
                                        <ChartistGraph
                                            data={test1bar}
                                            type="Bar"
                                            options={test1optionsBar}
                                            responsiveOptions={responsiveBar}
                                        />
                                    </div>
                                }
                                legend={
                                    <div className="legend">
                                        {this.createLegend(test1legendBar)}
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={8}>
                            <GraphCard
                                statsIcon="fa fa-history"
                                id="chartHours"
                                title="התנהגות משתמשים"
                                category="24 Hours performance"
                                stats="עודכן לפני 3 דקות"
                                content={
                                    <div className="ct-chart graph-card">
                                        <ChartistGraph
                                            data={dataSales}
                                            type="Line"
                                            //class="graph-card"
                                            options={optionsSales}
                                            responsiveOptions={responsiveSales}
                                        />
                                    </div>
                                    }
                                legend={
                                    <div className="legend">
                                        {this.createLegend(legendSales)}
                                    </div>
                                }
                            />
                        </Col>
                        <Col md={4}>
                            <GraphCard
                                id="chart-housing-legal"
                                title="סיוע מגורים, משפטי"
                                category= {this.housing_legal(test1bar)} // {" השוואה התחלה מול סיום" + " (36 משפחות) "}
                                className='graph-card-hist'
                                stats="עדכון מתוך תמונות מצב"
                                statsIcon="fa fa-check"
                                content={
                                    <div className="ct-chart graph-card">
                                        <ChartistGraph
                                            data={test1bar}
                                            type="Bar"
                                            options={test1optionsBar}
                                            responsiveOptions={responsiveBar}
                                        />
                                    </div>
                                }
                                legend={
                                    <div className="legend">
                                        {this.createLegend(test1legendBar)}
                                    </div>
                                }
                            />
                        </Col>
                            </Row>*/}
                </Grid>
            </div>
        </YahavDBStatsProvider>
        )
    }
}

export default Dashboard;
